import React, { Component, Suspense } from "react";
import dotenv from "dotenv";
import { BrowserRouter as Router, Redirect, Switch } from "react-router-dom";
import { LayoutRoute, MainLayout, EmptyLayout } from "./components/Layout";
import { AxiosProvider } from "react-axios";
import axios from "axios";

// Suspense Loading
import LoadingOverlay from "react-loading-overlay";
import HashLoader from "react-spinners/HashLoader";

import componentQueries from "react-component-queries";

import { HighwayApiUrlProvider, ArterialApiUrlProvider, LinksApiUrlProvider, InsightsCongestionUrlProvider, InsightsTransitUrlProvider } from "./components/Providers";

import "./styles/adms.scss";

// Pages (lazy loading)
import { AuthPage, STATE_LOGIN, STATE_SIGNUP } from "./pages/AuthPage";
const LandingPage = React.lazy(() => import("./pages/LandingPage"));
const RoutingPage = React.lazy(() => import("./pages/RoutingPage"));
const DashboardPage = React.lazy(() => import("./pages/DashboardPage"));
const TrafficChartsPage = React.lazy(() => import("./pages/TrafficChartsPage"));
const SensorMapPage = React.lazy(() => import("./pages/SensorMapPage"));
const TrafficMapPage = React.lazy(() => import("./pages/TrafficMapPage"));
const NeighborhoodMapPage = React.lazy(() => import("./pages/NeighborhoodMapPage"));
const CoronavirusPage = React.lazy(() => import("./pages/CoronavirusPage"));

dotenv.config();

const axiosInstance = axios.create({
  baseURL: "",
  headers: {
    Accept: "application/json"
  },
  timeout: 60000
});

class App extends Component {
  render() {
    return (
      <Suspense
        fallback={
          <LoadingOverlay
            active
            classNamePrefix={"SuspenseLoader_"}
            spinner={<HashLoader size={85} color={"#FFCC00"} />} />
        }
      >
        <Router>
          <Switch>
            <Redirect exact from={"/"} to="/app" />
            <Router basename={"/app"}>
              <Switch>
                <LayoutRoute
                  path="/"
                  exact
                  layout={MainLayout}
                  component={() => (
                    <LandingPage />
                  )}
                />
                <LayoutRoute
                  path="/route"
                  layout={EmptyLayout}
                  component={() => (
                    <RoutingPage />
                  )}
                />
                <LayoutRoute
                  path="/login"
                  exact
                  layout={EmptyLayout}
                  component={props => (
                    <AuthPage {...props} authState={STATE_LOGIN} />
                  )}
                />
                <LayoutRoute
                  path="/signup"
                  exact
                  layout={EmptyLayout}
                  component={props => (
                    <AuthPage {...props} authState={STATE_SIGNUP} />
                  )}
                />
                <AxiosProvider instance={axiosInstance}>
                  <LayoutRoute
                    path="/dashboard"
                    exact
                    layout={MainLayout}
                    component={props => (
                      <DashboardPage
                        {...props}
                        apiCongestionUrlProvider={InsightsCongestionUrlProvider}
                        apiTransitUrlProvider={InsightsTransitUrlProvider}
                      />
                    )}
                  />
                  <LayoutRoute
                    path="/charts/highway"
                    exact
                    layout={MainLayout}
                    component={props => (
                      <TrafficChartsPage
                        {...props}
                        apiUrlProvider={HighwayApiUrlProvider}
                      />
                    )}
                  />
                  <LayoutRoute
                    path="/charts/arterial"
                    exact
                    layout={MainLayout}
                    component={props => (
                      <TrafficChartsPage
                        {...props}
                        apiUrlProvider={ArterialApiUrlProvider}
                      />
                    )}
                  />
                  <LayoutRoute
                    path="/maps/sensors"
                    exact
                    layout={MainLayout}
                    component={props => (
                      <SensorMapPage {...props} linksUrlProvider={LinksApiUrlProvider} />
                    )}
                  />
                  <LayoutRoute
                    path="/maps/traffic/live"
                    exact
                    layout={MainLayout}
                    component={props => (
                      <TrafficMapPage {...props} />
                    )}
                  />
                  <LayoutRoute
                    path="/maps/counties"
                    exact
                    layout={MainLayout}
                    component={props => (
                      <NeighborhoodMapPage {...props} />
                    )}
                  />
                  <LayoutRoute
                      path="/coronavirus"
                      exact
                      layout={MainLayout}
                      component={props => (
                          <CoronavirusPage {...props} />
                      )}
                  />
                </AxiosProvider>
                <Redirect to="/" />
              </Switch>
            </Router>
          </Switch>
        </Router>
      </Suspense>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: "xs" };
  }

  if (576 < width && width < 767) {
    return { breakpoint: "sm" };
  }

  if (768 < width && width < 991) {
    return { breakpoint: "md" };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: "lg" };
  }

  if (width > 1200) {
    return { breakpoint: "xl" };
  }

  return { breakpoint: "xs" };
};

export default componentQueries(query)(App);
